import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Field, Form } from 'react-final-form';
import { Button } from 'ncoded-component-library';
import RfiAssigneeCombobox from '../RfiAssigneeCombobox';

import './RfiReassignForm.styles.scss';

type RfiReassignFormProps = {
  className?: string;
  assignedEmails: string[];
  isSingleAssignee: boolean;
  distinctAssignees: string[];
  loading?: boolean;
  onSubmit: (values: { assignedTo: string }) => Promise<void>;
};

const RfiReassignForm: React.FC<RfiReassignFormProps> = (props) => {
  const {
    className,
    assignedEmails,
    isSingleAssignee,
    distinctAssignees,
    loading,
    onSubmit,
  } = props;

  const { t } = useTranslation();

  const classes = classNames('rfi-reassign-form', className);

  return (
    <Form
      initialValues={{ assignedTo: '' }}
      onSubmit={onSubmit}
      render={({ submitting, values: { assignedTo }, handleSubmit }) => (
        <form className={classes} onSubmit={handleSubmit}>
          <p className="rfi-reassign-categories-modal__label">
            {t('assignToLabel')}
          </p>

          <Field
            name="assignedTo"
            component={RfiAssigneeCombobox}
            people={assignedEmails}
          />

          <p className="rfi-reassign-categories-modal__muted-text">
            {isSingleAssignee
              ? t('reassignReminderHistorySingle', {
                  email: distinctAssignees[0],
                })
              : t('reassignReminderHistoryMultiple')}
          </p>

          <div className="rfi-reassign-form__actions">
            <Button
              type="submit"
              disabled={submitting || loading || !assignedTo}
            >
              {t('reassign')}
            </Button>
          </div>
        </form>
      )}
    />
  );
};

export default RfiReassignForm;
